import { supabase } from '@/lib/supabase';
import type { ChatMessage, ChatTarget } from './types';
import { MESSAGE_SELECT_FIELDS } from './messageSelectFields';
import { filterColumn, targetId } from './chatTarget';

const OLDER_MESSAGES_PAGE_SIZE = 50;

export async function fetchOlderMessages(params: {
  target: ChatTarget;
  oldestCreatedAt: string;
}): Promise<ChatMessage[]> {
  const { target, oldestCreatedAt } = params;

  const { data, error } = await supabase
    .from('messages_new')
    .select(MESSAGE_SELECT_FIELDS)
    .eq(filterColumn(target), targetId(target))
    .lt('created_at', oldestCreatedAt)
    .order('created_at', { ascending: false })
    .limit(OLDER_MESSAGES_PAGE_SIZE);

  if (error) {
    throw error;
  }

  const rows = (data as ChatMessage[] | null) ?? [];
  // Return in oldest -> newest order so the caller can prepend directly.
  return rows.reverse();
}
